module.exports = __webpack_public_path__ + "img/engagement-photo-1.7733c26d.jpg";